import { create } from 'zustand';

const useChallanList = create((set) => ({
  sortingData: false,
  schedularDate: {},
  selectedStatus: "ALL",
  challanStatusInSelection: "ALL",
   
  setSortingData: (val) => set({ sortingData: val}),
  setSchedularDate: (val) => set({ schedularDate: val }),
  setSelectedStatus: (val) => set({ selectedStatus: val }),
  setChallanStatusInSelection: (val) => set({ challanStatusInSelection: val}),
   
}));
export default useChallanList;
